class ApiError<BodyType> extends Error {
  body?: BodyType;

  constructor(msg: string, body?: BodyType) {
    super(msg);
    this.body = body;
  }
}

export default ApiError;
